import Vue from "vue";
import WebApi from "./utils/api";
import { MethodService } from "./utils/serviceModel";
import { guid } from "./utils/index";
import go from "gojs";
if (!Vue.config.devtools) {
  Vue.config.silent = true;
}
Vue.config.productionTip = false;
Vue.prototype.$Api = new WebApi();
let win = window as IndexObject;
win.go = go;
Vue.prototype.$guid = guid;
Vue.prototype.$createService = (
  module: string,
  cls: string,
  method: string
) => {
  return new MethodService(module, cls, method);
};
